import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>ShopBoard</div>
        <p style={styles.sub}>Unified commerce dashboard</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={submit}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} required autoFocus />
          <label style={styles.label}>Password</label>
          <input style={styles.input} type="password" value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })} required />
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <Link to="/forgot-password" style={styles.link}>Forgot password?</Link>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f7' },
  card: { background: '#fff', borderRadius: 12, padding: '40px 36px', width: 360, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
  logo: { fontSize: 22, fontWeight: 600, color: '#1a1a2e', marginBottom: 4 },
  sub: { fontSize: 13, color: '#888', marginBottom: 24 },
  error: { background: '#FCEBEB', color: '#791F1F', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#444', marginBottom: 6, fontWeight: 500 },
  input: { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box', outline: 'none' },
  btn: { width: '100%', padding: '10px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 4 },
  link: { display: 'block', textAlign: 'center', marginTop: 16, fontSize: 13, color: '#534AB7', textDecoration: 'none' },
};
